var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.cssProps),attrs:{"id":"app"}},[_c('notification'),_c('destroyDialog'),(_vm.displayMenu)?_c('navigationMenu',{ref:"navigationMenu"}):_vm._e(),_c('v-main',[_c('router-view',{staticClass:"child-view"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }